import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface TrialBannerContextValue {
  isJdsVisible: boolean;
  setJdsVisible: (visible: boolean) => void;
  isNextGenVisible: boolean;
  setNextGenVisible: (visible: boolean) => void;
}

const TrialBannerContext = createContext<TrialBannerContextValue | undefined>(undefined);

export function TrialBannerProvider({ children }: { children: ReactNode }) {
  const [isJdsVisible, setJdsVisibleState] = useState(false);
  const [isNextGenVisible, setNextGenVisibleState] = useState(false);

  const setJdsVisible = useCallback((visible: boolean) => setJdsVisibleState(visible), []);
  const setNextGenVisible = useCallback((visible: boolean) => setNextGenVisibleState(visible), []);

  return (
    <TrialBannerContext.Provider
      value={{ isJdsVisible, setJdsVisible, isNextGenVisible, setNextGenVisible }}
    >
      {children}
    </TrialBannerContext.Provider>
  );
}

export function useTrialBannerContext(): TrialBannerContextValue {
  const ctx = useContext(TrialBannerContext);
  if (!ctx) {
    throw new Error('useTrialBannerContext must be used within a TrialBannerProvider');
  }
  return ctx;
}
